import { ViewerContext, localStorage } from "dash-ui";
import { useLogoutMutation } from "gql/generated.graphql";
import { useContext } from "react";
import * as Sentry from "@sentry/react";
import { client } from "gql/client";

export const useLogout = (): [() => void, boolean] => {
  const [logoutMutation, { loading }] = useLogoutMutation();
  const {
    setAccount,
    setTokens,
    setProfile,
    setBroker,
    setSubscription,
    setUserHasTrialed,
  } = useContext(ViewerContext);

  return [
    async () => {
      await logoutMutation({
        onCompleted: () => {
          client.clearStore();
        },
      });

      localStorage.setAccessToken("");
      localStorage.setRefreshToken("");
      localStorage.setRefreshTokenExpiry("");

      if (
        setAccount &&
        setTokens &&
        setProfile &&
        setBroker &&
        setSubscription &&
        setUserHasTrialed
      ) {
        setTokens({});
        setProfile({});
        setBroker({});
        setAccount(null);
        setSubscription(null);
        setUserHasTrialed(null);
        Sentry.getCurrentScope().clear();
      }
    },
    loading,
  ];
};
